import { render, staticRenderFns } from "./WidgetsDropdown.vue?vue&type=template&id=7bc9bee4&scoped=true"
import script from "./WidgetsDropdown.vue?vue&type=script&lang=js"
export * from "./WidgetsDropdown.vue?vue&type=script&lang=js"
import style0 from "./WidgetsDropdown.vue?vue&type=style&index=0&id=7bc9bee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc9bee4",
  null
  
)

export default component.exports